/* SWATCHES ON COLLECTION PAGE */

  const productCard = document.querySelectorAll('.card-information__wrapper');
  const imgData = document.querySelector('#colorFile').dataset.imgFile;

  const imgRaw = JSON.stringify(imgData);
  const imgSplit = imgRaw.split(/[,]/).map(img => img.replace(/[\"\s{}]/g, '')).map(s => s.split('.'));
  const imgJSON = Object.fromEntries(imgSplit);

  const colorData = document.querySelector('#colorFile').dataset.colorFile;
  const colorRaw = JSON.stringify(colorData);
  const colorSplit = colorRaw.split(/[,]/).map(col => col.replace(/[\"\s{}]/g, '')).map(s => s.split(':'));
  const colorJSON = Object.fromEntries(colorSplit);

  const imgLink = document.querySelector('#colorFile').dataset.imageLink;

  console.log('This is for images:', imgJSON);
  console.log('This is for colors:', colorJSON);

 productCard.forEach(
  function(card) {
  for(const img in imgJSON) {
    const val = `${imgJSON[img]}`;
    const swatchImg = card.querySelector(`[data-color="${img}"]`);
    const infoImg = card.querySelector(`[data-info-image="${img}"]`);
 

    if(swatchImg){
      const imageName = `${img}.${val}`;
      const assetUrl = imgLink.split('?')[0] + `${imageName}`;
      swatchImg.style.backgroundImage = `url('${assetUrl}')`;

      if(infoImg) {
        infoImg.src = assetUrl;
        infoImg.style.display = 'block';
      }
    }
  }


  for(const color in colorJSON) {
    const val = `${colorJSON[color]}`;
    const swatchColor = card.querySelector(`[data-color="${color}"]`);
    const values = '{{values}}';

    if(swatchColor){
      swatchColor.style.backgroundColor = val;
    }
  }

  const labels = card.querySelectorAll('.labelColor');
  labels.forEach((label) => {  
    if(label.style.backgroundColor == '' ){
      label.classList.add('no-background')
    }
  })

})